exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.verified-photos-list[data-v-242e1485] {\n  padding: 1rem;\n.small-photo[data-v-242e1485] {\n    max-width: 120px;\n    border-radius: 4px;\n}\n}\n", ""]);

// exports
